module.exports = __webpack_public_path__ + "static/media/mcsedmikraska.aaf7fa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/mcsedmikraska.png
// module id = 446
// module chunks = 0